import React from "react";
import { Box } from "@mui/material";
import ExternalInfoRow from "./ExternalInfoRow";
import MDButton from "components/MDButton";
import { useSelector, useDispatch } from "react-redux";
// import {
//   addExternalInfo,
// } from "redux/slices/orgSlice";
import { addExternalInfo } from "features/OrgAdmin/orgAdminSlice";

export default function ExternalInfoForm() {
  const dispatch = useDispatch();
  const externalInfo = useSelector((state) => state.org.externalInfo);

  const handleAdd = () => {
    dispatch(addExternalInfo());
  };

  return (
    <Box sx={{ mt: 6 }}>
      {externalInfo.map((data, index) => (
        <Box key={index} sx={{ mb: 2 }}>
          <ExternalInfoRow index={index} data={data} />
        </Box>
      ))}

      <MDButton variant="contained" color="info" onClick={handleAdd}>
        + Add External Info
      </MDButton>
    </Box>
  );
}
